// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"294":"9228e198","562":"893132cc"}[chunkId] + ".chunk.js");